import { render, staticRenderFns } from "./officeDashboard.vue?vue&type=template&id=45cfd753&scoped=true"
import script from "./officeDashboard.vue?vue&type=script&lang=js"
export * from "./officeDashboard.vue?vue&type=script&lang=js"
import style0 from "./officeDashboard.vue?vue&type=style&index=0&id=45cfd753&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cfd753",
  null
  
)

export default component.exports